// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"f18c4d5d","327":"0e4c85e6","498":"eb04960f","551":"1042509a","750":"4b584944","851":"72889788"}[chunkId] + ".chunk.js";
};